/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * Promotion item with image and link
 * @export
 * @interface SurfacePromoItem
 */
export interface SurfacePromoItem {
    /**
     * 
     * @type {string}
     * @memberof SurfacePromoItem
     */
    imageId?: string;
    /**
     * 
     * @type {string}
     * @memberof SurfacePromoItem
     */
    imageUrl?: string;
    /**
     * 
     * @type {string}
     * @memberof SurfacePromoItem
     */
    title?: string;
    /**
     * 
     * @type {string}
     * @memberof SurfacePromoItem
     */
    description?: string;
    /**
     * 
     * @type {string}
     * @memberof SurfacePromoItem
     */
    url?: string;
}

/**
 * Check if a given object implements the SurfacePromoItem interface.
 */
export function instanceOfSurfacePromoItem(value: object): value is SurfacePromoItem {
    return true;
}

export function SurfacePromoItemFromJSON(json: any): SurfacePromoItem {
    return SurfacePromoItemFromJSONTyped(json, false);
}

export function SurfacePromoItemFromJSONTyped(json: any, ignoreDiscriminator: boolean): SurfacePromoItem {
    if (json == null) {
        return json;
    }
    return {
        
        'imageId': json['imageId'] == null ? undefined : json['imageId'],
        'imageUrl': json['imageUrl'] == null ? undefined : json['imageUrl'],
        'title': json['title'] == null ? undefined : json['title'],
        'description': json['description'] == null ? undefined : json['description'],
        'url': json['url'] == null ? undefined : json['url'],
    };
}

export function SurfacePromoItemToJSON(json: any): SurfacePromoItem {
    return SurfacePromoItemToJSONTyped(json, false);
}

export function SurfacePromoItemToJSONTyped(value?: SurfacePromoItem | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'imageId': value['imageId'],
        'imageUrl': value['imageUrl'],
        'title': value['title'],
        'description': value['description'],
        'url': value['url'],
    };
}

